import { render, staticRenderFns } from "./MicroTopics.vue?vue&type=template&id=d9452350&scoped=true&"
import script from "./MicroTopics.vue?vue&type=script&lang=js&"
export * from "./MicroTopics.vue?vue&type=script&lang=js&"
import style0 from "./MicroTopics.vue?vue&type=style&index=0&id=d9452350&scoped=true&lang=css&"
import style1 from "./MicroTopics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9452350",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCol,VDialog,VPagination,VRow,VTab,VTabs})
